import { render, staticRenderFns } from "./screen.vue?vue&type=template&id=a93d1a5c&scoped=true"
import script from "./screen.vue?vue&type=script&lang=ts"
export * from "./screen.vue?vue&type=script&lang=ts"
import style0 from "./screen.vue?vue&type=style&index=0&id=a93d1a5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a93d1a5c",
  null
  
)

export default component.exports